import logRoutes from "./logRoutes"
import guideRoutes from "./guideRoutes"
import lhComponentsRoutes from "./lhComponentsRoutes"
import feedbackRoutes from "./feedbackRoutes"
let routes=[];
routes.push(...logRoutes);
routes.push(...guideRoutes);
routes.push(...lhComponentsRoutes);
routes.push(...feedbackRoutes);
export default routes;